/* unplugin-vue-components disabled */import { render } from "./CustomerEditForm.vue?vue&type=template&id=209eeaee&ts=true"
import script from "./CustomerEditForm.vue?vue&type=script&lang=ts"
export * from "./CustomerEditForm.vue?vue&type=script&lang=ts"

import "./CustomerEditForm.vue?vue&type=style&index=0&id=209eeaee&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__